import { render } from "./sh-weilogin.vue?vue&type=template&id=21b1a86a&scoped=true"
import script from "./sh-weilogin.vue?vue&type=script&lang=js"
export * from "./sh-weilogin.vue?vue&type=script&lang=js"

import "./sh-weilogin.vue?vue&type=style&index=0&id=21b1a86a&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b1a86a"]])

export default __exports__